var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * Service to search for a consumer by phone or name
 *
 * @method ConsumerInfoNotesWS
 * @returns {ConsumerInfoNotesWS}
 */
function ConsumerInfoNotesWS() {
    var self;

    // Predicate this Web Service handler on the Abstract class of a Web
    // Service handler. This establishes core functionality required of
    // these such handlers, which can be overwritten by methods below.
    AbstractWS.apply(this, arguments);

    self = this;
    self.name = 'ConsumerInfoNotesWS';
    self.method('GET');


	/**
	 * Abstract override method
	 *
	 * @method doRequest
	 * @param {Function} fCallback
	 * @returns none
	 */
    self.doRequest = function (fCallback) {
        var selectedConsumer = vm.selectedConsumer();
        var queue = vm.queuesWS.getQueueById(selectedConsumer.queueId);

        if (selectedConsumer && selectedConsumer.merchantConsumerInfoId) {
            self.serviceURL = ko.computed(function () {
                return '/qless/api/v1/employee/location/' + queue.locationId + '/consumer/' + selectedConsumer.merchantConsumerInfoId;
            });
            AbstractWS.prototype.doRequest.call(self, fCallback);
        }
    };


	/**
	 * Converts returned XML data into SpotModels, with custom properties
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {ConsumerSearchWS}
	 */
    self.processData = function (data) {
        // Call the superclass method to perform any core actions
        AbstractWS.prototype.processData.call(self, data);
        json = xmlToJson.parse(data);
        //Ideally we want to get the notes because the consumer had a merchantConsumerInfoId
        if (json.merchantConsumerInfos && json.merchantConsumerInfos.info && json.merchantConsumerInfos.info.notes) {
            var consumerNotes = json.merchantConsumerInfos.info.notes;
            vm.selectedConsumerNotes(consumerNotes);
        }
    };

    return self;
};

ConsumerInfoNotesWS.prototype = AbstractWS.prototype;
ConsumerInfoNotesWS.prototype.constructor = ConsumerInfoNotesWS;



module.exports = ConsumerInfoNotesWS;
